import React, { FC } from "react";
import PageLayout from "layouts/PageLayout";
import PageHeader from "containers/PageHeader";
import OverviewInfoCards from "containers/OverviewInfoCards/OverviewInfoCards";
import { OverviewCharts } from "containers/OverviewCharts";
import { BucketsBlock } from "containers/BucketsBlock";

const StorageOverviewPage: FC = () => {
  return (
    <PageLayout>
      <PageHeader title="Storage Overview" />
      <OverviewInfoCards />
      <OverviewCharts />
      <BucketsBlock />
    </PageLayout>
  );
};

export default StorageOverviewPage;
